import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7446d7aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Répondant", -1 /* HOISTED */))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "form-group col-sm-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.repondant.titreCivilite" }, "Titre de civilité", -1 /* HOISTED */))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "form-group col-sm-6"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.repondant.titreCivilitePrecision" }, "Précisez", -1 /* HOISTED */))
const _hoisted_12 = ["readonly"]
const _hoisted_13 = { class: "form-group col-sm-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.repondant.prenom" }, "Prénom", -1 /* HOISTED */))
const _hoisted_15 = ["readonly"]
const _hoisted_16 = { class: "form-group col-sm-12" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.repondant.nom" }, "Nom", -1 /* HOISTED */))
const _hoisted_18 = ["readonly"]
const _hoisted_19 = { class: "form-group col-sm-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.repondant.fonction" }, "Fonction", -1 /* HOISTED */))
const _hoisted_21 = ["readonly"]
const _hoisted_22 = { class: "form-group col-sm-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.repondant.courriel" }, "Courriel", -1 /* HOISTED */))
const _hoisted_24 = ["readonly"]
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Personne ressource", -1 /* HOISTED */))
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "form-group col-sm-12" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "entite.personneRessource.memeQueRepondant"
}, " La personne ressource est la même que le répondant ", -1 /* HOISTED */))
const _hoisted_33 = {
  key: 0,
  class: "form-group col-sm-12"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.personneRessource.nomComplet" }, "Nom complet", -1 /* HOISTED */))
const _hoisted_35 = ["readonly"]
const _hoisted_36 = {
  key: 1,
  class: "form-group col-sm-12"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.personneRessource.fonction" }, "Fonction", -1 /* HOISTED */))
const _hoisted_38 = ["readonly"]
const _hoisted_39 = {
  key: 2,
  class: "form-group col-sm-12"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.personneRessource.courriel" }, "Courriel", -1 /* HOISTED */))
const _hoisted_41 = ["readonly"]
const _hoisted_42 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_43 = {
  key: 3,
  class: "form-group col-sm-12"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.personneRessource.telephone" }, "Téléphone ", -1 /* HOISTED */))
const _hoisted_45 = ["placeholder", "readonly"]
const _hoisted_46 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_47 = {
  key: 4,
  class: "form-group col-sm-12"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.personneRessource.commentaire" }, "Commentaire", -1 /* HOISTED */))
const _hoisted_49 = ["readonly"]
const _hoisted_50 = { class: "form-group col-sm-12" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "entite.courrielTransmission" }, " Autre(s) adresse(s) courriel à ajouter lors de l'envoi (Séparer par des virgules) ", -1 /* HOISTED */))
const _hoisted_52 = ["readonly"]
const _hoisted_53 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Informations sur l'entité",
    "forced-opened": _ctx.forcedOpened,
    opened: ""
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" <div class=\"form-group col-sm-4\">\r\n            <label for=\"entite.codeGeographique\">Code géographique</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"entite.codeGeographique\"\r\n                v-model=\"reglement.entite.codeGeographique\"\r\n                :class=\"triedSave && !reglement.entite.codeGeographique ? 'is-invalid' : ''\" />\r\n            <p class=\"text-danger\" v-if=\"triedSave && !reglement.infosLegales.numero\">Le numéro est requis pour sauvegarder\r\n            </p>\r\n        </div> "),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  id: "entite.repondant.titreCivilite",
                  disabled: _ctx.readonly,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reglement.entite.repondant.titreCivilite) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TitreCivilite, (titre) => {
                    return (_openBlock(), _createElementBlock("option", { value: titre }, _toDisplayString(titre), 9 /* TEXT, PROPS */, _hoisted_9))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_8), [
                  [_vModelSelect, _ctx.reglement.entite.repondant.titreCivilite]
                ])
              ]),
              (_ctx.reglement.entite.repondant.titreCivilite === _ctx.TitreCivilite.Autre)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "entite.repondant.titreCivilitePrecision",
                      readonly: _ctx.readonly,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reglement.entite.repondant.titreCivilitePrecision) = $event))
                    }, null, 8 /* PROPS */, _hoisted_12), [
                      [_vModelText, _ctx.reglement.entite.repondant.titreCivilitePrecision]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "entite.repondant.prenom",
                  readonly: _ctx.readonly,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reglement.entite.repondant.prenom) = $event))
                }, null, 8 /* PROPS */, _hoisted_15), [
                  [_vModelText, _ctx.reglement.entite.repondant.prenom]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "entite.repondant.nom",
                  readonly: _ctx.readonly,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reglement.entite.repondant.nom) = $event))
                }, null, 8 /* PROPS */, _hoisted_18), [
                  [_vModelText, _ctx.reglement.entite.repondant.nom]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "entite.repondant.fonction",
                  readonly: _ctx.readonly,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reglement.entite.repondant.fonction) = $event))
                }, null, 8 /* PROPS */, _hoisted_21), [
                  [_vModelText, _ctx.reglement.entite.repondant.fonction]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", !_ctx.champsValides.personneRessource.courriel ? 'is-invalid' : '']),
                  id: "entite.repondant.courriel",
                  readonly: _ctx.readonly,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reglement.entite.repondant.courriel) = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onREpondantCourrielChange && _ctx.onREpondantCourrielChange(...args)))
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_24), [
                  [_vModelText, _ctx.reglement.entite.repondant.courriel]
                ]),
                (!_ctx.champsValides.repondant.courriel)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.messagesValidation.repondant.courriel), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  disabled: _ctx.readonly,
                  id: "entite.personneRessource.memeQueRepondant",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reglement.entite.personneRessource.memeQueRepondant) = $event)),
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onPersonneRessourceMemeQueRepondantChange && _ctx.onPersonneRessourceMemeQueRepondantChange(...args)))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_31), [
                  [_vModelCheckbox, _ctx.reglement.entite.personneRessource.memeQueRepondant]
                ]),
                _hoisted_32
              ]),
              (!_ctx.reglement.entite.personneRessource.memeQueRepondant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "entite.personneRessource.nomComplet",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reglement.entite.personneRessource.nomComplet) = $event)),
                      readonly: _ctx.readonly
                    }, null, 8 /* PROPS */, _hoisted_35), [
                      [_vModelText, _ctx.reglement.entite.personneRessource.nomComplet]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.reglement.entite.personneRessource.memeQueRepondant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "entite.personneRessource.fonction",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.reglement.entite.personneRessource.fonction) = $event)),
                      readonly: _ctx.readonly
                    }, null, 8 /* PROPS */, _hoisted_38), [
                      [_vModelText, _ctx.reglement.entite.personneRessource.fonction]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.reglement.entite.personneRessource.memeQueRepondant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: _normalizeClass(["form-control", !_ctx.champsValides.personneRessource.courriel ? 'is-invalid' : '']),
                      id: "entite.personneRessource.courriel",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.reglement.entite.personneRessource.courriel) = $event)),
                      onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onPersonneRessourceCourrielChange && _ctx.onPersonneRessourceCourrielChange(...args))),
                      readonly: _ctx.readonly
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_41), [
                      [_vModelText, _ctx.reglement.entite.personneRessource.courriel]
                    ]),
                    (!_ctx.champsValides.personneRessource.courriel)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.messagesValidation.personneRessource.courriel), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.reglement.entite.personneRessource.memeQueRepondant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", !_ctx.champsValides.personneRessource.telephone ? 'is-invalid' : '']),
                      id: "entite.personneRessource.telephone",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.reglement.entite.personneRessource.telephone) = $event)),
                      onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onPersonneRessourceTelephoneChange && _ctx.onPersonneRessourceTelephoneChange(...args))),
                      placeholder: _ctx.forcedOpened ? '' : '999-999-9999#999999',
                      readonly: _ctx.readonly
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_45), [
                      [_vModelText, _ctx.reglement.entite.personneRessource.telephone]
                    ]),
                    (!_ctx.champsValides.personneRessource.telephone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                          _createTextVNode(_toDisplayString(_ctx.messagesValidation.personneRessource.telephone) + " ", 1 /* TEXT */),
                          _createCommentVNode(" TODO AP Format téléphone avec poste ")
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.reglement.entite.personneRessource.memeQueRepondant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "entite.personneRessource.commentaire",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.reglement.entite.personneRessource.commentaire) = $event)),
                      readonly: _ctx.readonly
                    }, null, 8 /* PROPS */, _hoisted_49), [
                      [_vModelText, _ctx.reglement.entite.personneRessource.commentaire]
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          class: _normalizeClass(["form-control", !_ctx.champsValides.courrielTransmission ? 'is-invalid' : '']),
          id: "entite.courrielTransmission",
          readonly: _ctx.readonly,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.reglement.entite.courrielTransmission) = $event)),
          onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onCourrielTransmissionChange && _ctx.onCourrielTransmissionChange(...args)))
        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_52), [
          [_vModelText, _ctx.reglement.entite.courrielTransmission]
        ]),
        (!_ctx.champsValides.courrielTransmission)
          ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(_ctx.messagesValidation.courrielTransmission), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["forced-opened"]))
}